import { useMutation } from '@apollo/client';
import type { UseApiKeyCreate } from '@openx/components-organization/lib/utils/context/OrganizationHookTypes';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { CreateApiKeyDocument } from '../../../graphql/mutation/users/CreateApiKey.generated';

const IN_90_DAYS = 'P90D';

export const useApiKeyCreate: UseApiKeyCreate = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const [createApiKeyMutation, { loading }] = useMutation(CreateApiKeyDocument, {
    awaitRefetchQueries: true,
    refetchQueries: ['GetOrgApiKeys'],
  });

  const createApiKey = useCallback(
    async (name: string, organizationId: string) => {
      try {
        const result = await createApiKeyMutation({
          variables: { expiresIn: IN_90_DAYS, name, parent_account_id: organizationId },
        });

        return result.data?.createServiceAccountUnderParentAccount;
      } catch (error) {
        const defaultErrorMessage = t('Failed to create API Key');
        const message = error[0]?.message;

        enqueueSnackbar(message ?? defaultErrorMessage, { variant: 'error' });
      }
    },
    [createApiKeyMutation, enqueueSnackbar, t]
  );

  return { createApiKey, loading };
};
